import React from 'react';
import {BarChart} from '@mui/x-charts/BarChart';

import {DashboardMensajesPorEtapa, DashboardMensajesPorEtapaEstadoFields} from "../types/dashboard";
import {Stack, useTheme} from "@mui/material";
import {DefaultizedPieValueType, pieArcLabelClasses, PieChart} from "@mui/x-charts";
import CardActions from "../../sistema/components/CardActions";


interface MensajesPorEstadoChartProps {
  data: DashboardMensajesPorEtapa[];
}

function MensajesPorEstadoChart({data}: MensajesPorEstadoChartProps) {
  const {palette} = useTheme()


  const COLOR_MAP: { [key: string]: string } = {
    'Aprobadas': palette.success.main,
    'En Curso': palette.info.main,
    'Rechazadas': palette.error.main,
    'Nuevos': palette.primary.main,
  };

  const getArcLabel = (params: DefaultizedPieValueType) => {
    const total = data?.map(x => x[DashboardMensajesPorEtapaEstadoFields.CantMensajes]).reduce((a, b) => a + b, 0)
    const percent = params.value / total

    return `${(percent * 100).toFixed(0)}%`
  };

  return (
    <CardActions title={'Mensajes por estado'}
                 colapsable
    >
      <Stack direction={'row'}>

        {/*<BarChart*/}
        {/*  dataset={data}*/}
        {/*  xAxis={[{*/}
        {/*    scaleType: 'band', dataKey: DashboardMensajesPorEtapaEstadoFields.EtapaEstado,*/}
        {/*    colorMap: {*/}
        {/*      type: 'ordinal',*/}
        {/*      values: ['Aprobadas', 'En Curso', 'Rechazadas', 'Nuevos'],*/}
        {/*      colors: [palette.success.main, palette.info.main, palette.error.main, palette.primary.main]*/}
        {/*    }*/}
        {/*  }]}*/}
        {/*  series={[*/}
        {/*    {*/}
        {/*      dataKey: DashboardMensajesPorEtapaEstadoFields.CantMensajes,*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  width={600}*/}
        {/*  height={400}*/}
        {/*/>*/}

        <PieChart
          dataset={data}

          series={[
            {
              outerRadius: 120,
              innerRadius: 50,
              paddingAngle: 1,
              data: data?.map(x => ({
                id: x.id,
                value: x[DashboardMensajesPorEtapaEstadoFields.CantMensajes],
                label: x[DashboardMensajesPorEtapaEstadoFields.EtapaEstado],
                color: COLOR_MAP[x[DashboardMensajesPorEtapaEstadoFields.EtapaEstado]],
              })),
              arcLabel: getArcLabel,
              arcLabelMinAngle: 10,


              // arcLabel: getArcLabel,
            },
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'white',
              fontSize: 14,
            },
          }}
          width={600}
          height={400}
        />

      </Stack>
    </CardActions>
  );
}

export default MensajesPorEstadoChart;